// Wire names of the projectable user fields. The search response echoes exactly the
// requested keys, so consumers read results by these same names — keep them in one place.
export const UserSearchField = {
  ID: 'id',
  FIRST_NAME: 'firstName',
  MIDDLE_INITIAL: 'middleInitial',
  LAST_NAME: 'lastName',
  SUFFIX: 'suffix',
  EMAIL_ADDRESS: 'emailAddress',
  PHONE_NUMBER: 'phoneNumber',
  IS_DELETED: 'isDeleted',
};

export const DeletedUsersPolicy = {
  EXCLUDE_DELETED: 'ExcludeDeleted',
  INCLUDE_DELETED: 'IncludeDeleted',
};

export const RolesFilterOperator = {
  AND: 'And',
  OR: 'Or',
};

// Server rejects a longer ids filter with a typed 400 (SearchIdsExceedCap).
export const USER_SEARCH_MAX_IDS = 500;

// The field set getUserDisplayName consumes — search returns ONLY requested fields,
// so both display-name call sites must project the same list.
export const USER_DISPLAY_NAME_FIELDS = [
  UserSearchField.ID,
  UserSearchField.FIRST_NAME,
  // middle initial + suffix are part of the rendered display name
  // ([firstName, middleInitial, lastName, suffix]), so a scoped by-ids read must project them too
  // or attribution shows "John Smith" instead of "John Q. Smith Jr.".
  UserSearchField.MIDDLE_INITIAL,
  UserSearchField.LAST_NAME,
  UserSearchField.SUFFIX,
  UserSearchField.EMAIL_ADDRESS,
];

// What activity items need to show a contact's name for an email address or call number.
export const ACTIVITY_CONTACT_FIELDS = [
  UserSearchField.FIRST_NAME,
  UserSearchField.LAST_NAME,
  UserSearchField.EMAIL_ADDRESS,
  UserSearchField.PHONE_NUMBER,
];
